<template>
  <div class="logo" :style="style">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 732.1 284.15">
      <g id="cdr_layer10">
        <path
          class="cls-1"
          d="M454.76-305.22c-32.83,0-61.88-10.71-84.83-31.17-31.84-28.39-52.39-75.74-52.55-126.76,0-12.88,10-23.93,22.87-24.41A23.79,23.79,0,0,1,365-463.79c0,29.27,10.72,68.78,36.63,91.89C414.12-360.74,428-354.47,446-353.18c3.68.26,9.81.36,9.81-3.34v-106.6c0-12.81,9.84-23.83,22.64-24.44a23.79,23.79,0,0,1,24.94,23.76v132.86c0,10.9-8.71,18.54-19.37,22.49C478.69-306.46,470-305.22,454.76-305.22Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M609.73-445.61a49.58,49.58,0,0,0-49.52,49.52,49.58,49.58,0,0,0,49.52,49.52,49.58,49.58,0,0,0,49.52-49.52A49.58,49.58,0,0,0,609.73-445.61Zm0,140.68a91.26,91.26,0,0,1-91.16-91.16,91.26,91.26,0,0,1,91.16-91.16,91.26,91.26,0,0,1,91.16,91.16A91.26,91.26,0,0,1,609.73-304.93Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M803.17-304.93A91.26,91.26,0,0,1,712-396.09a91.26,91.26,0,0,1,91.16-91.16,90.57,90.57,0,0,1,64.46,26.7,20.82,20.82,0,0,1,0,29.44,20.82,20.82,0,0,1-29.44,0,49.2,49.2,0,0,0-35-14.5,49.58,49.58,0,0,0-49.52,49.52,49.58,49.58,0,0,0,49.52,49.52,49.2,49.2,0,0,0,35-14.5,20.82,20.82,0,0,1,29.44,0,20.82,20.82,0,0,1,0,29.44A90.56,90.56,0,0,1,803.17-304.93Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M915.46-403.61A49.61,49.61,0,0,1,964.4-445.5a49.44,49.44,0,0,1,26,7.42,4.22,4.22,0,0,1-.45,7.42L921.4-399.11A4.22,4.22,0,0,1,915.46-403.61ZM1029-383.17c-8.58-1.4-16.89,3.15-21.06,10.8a49.51,49.51,0,0,1-43.54,25.9,49.11,49.11,0,0,1-26-7.4,4.22,4.22,0,0,1,.46-7.42L1037-406.48h0a19.75,19.75,0,0,0,10.73-26.41,91.29,91.29,0,0,0-46.59-46.43,90.63,90.63,0,0,0-36.77-7.81,90.57,90.57,0,0,0-40,9.26A91.26,91.26,0,0,0,873.25-396a90.44,90.44,0,0,0,8.12,37.53c.07.19.13.4.22.59s.21.39.3.58a91.28,91.28,0,0,0,82.52,52.45,91.11,91.11,0,0,0,80.14-47.69C1051.18-364.74,1044.31-380.68,1029-383.17Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M1002.92-498.13c-5.25-7.06-27.42-27.78-38.44-27.88-11,.1-33.19,20.82-38.44,27.88-4.79,6.43,1.25,7.2,5,5.34,10.35-5.2,22-9.41,33.49-9.43S987.62-498,998-492.79C1001.69-490.93,1007.73-491.7,1002.92-498.13Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M723.39-241.86h5.13a6.17,6.17,0,0,0,5.82-4.13l10.38-29.62a1.83,1.83,0,0,1,1.72-1.22h7a9.91,9.91,0,0,0,9.34-6.63l.33-.93a.84.84,0,0,0-.11-.77.82.82,0,0,0-.69-.35H726.27a3,3,0,0,0-2.8,2l-2,5.57a.83.83,0,0,0,.11.77.83.83,0,0,0,.69.35h10.35a1.82,1.82,0,0,1,1.48.77,1.82,1.82,0,0,1,.23,1.66l-11.28,32.13a.3.3,0,0,0,0,.28A.3.3,0,0,0,723.39-241.86Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M802.3-283.46l.58-1.64a.3.3,0,0,0,0-.28.31.31,0,0,0-.25-.13h-26a9.91,9.91,0,0,0-9.34,6.63l-10.86,30.93a4.53,4.53,0,0,0,.58,4.16,4.52,4.52,0,0,0,3.73,1.93h20.64a6.7,6.7,0,0,0,5.82-4.13l1.45-4.14a.31.31,0,0,0,0-.28.3.3,0,0,0-.25-.13H769.58a1.29,1.29,0,0,1-1-.54,1.28,1.28,0,0,1-.17-1.17l1.89-5.42a2.37,2.37,0,0,1,2.23-1.58h6.78a9.91,9.91,0,0,0,9.34-6.63l.63-1.79a.31.31,0,0,0,0-.28.3.3,0,0,0-.25-.13H775.73a1.29,1.29,0,0,1-1-.54,1.29,1.29,0,0,1-.17-1.17l1.92-5.46a2.36,2.36,0,0,1,2.22-1.58H793A9.91,9.91,0,0,0,802.3-283.46Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M870.51-276.83a9.91,9.91,0,0,0,9.35-6.63l.58-1.64a.31.31,0,0,0,0-.28.3.3,0,0,0-.25-.13h-26a9.91,9.91,0,0,0-9.35,6.63l-10.86,30.93a4.52,4.52,0,0,0,.58,4.16,4.52,4.52,0,0,0,3.73,1.93h20.64a6.71,6.71,0,0,0,5.82-4.13l1.45-4.14a.3.3,0,0,0,0-.28.31.31,0,0,0-.25-.13H847.14a1.3,1.3,0,0,1-1.05-.54,1.3,1.3,0,0,1-.17-1.17l1.9-5.42a2.36,2.36,0,0,1,2.22-1.58h6.79a9.91,9.91,0,0,0,9.34-6.63l.63-1.79a.3.3,0,0,0,0-.28.3.3,0,0,0-.25-.13H853.29a1.3,1.3,0,0,1-1.05-.55,1.29,1.29,0,0,1-.16-1.18l1.91-5.46a2.35,2.35,0,0,1,2.22-1.58Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M919.68-283.46l.57-1.64a.3.3,0,0,0,0-.28.3.3,0,0,0-.25-.13H894a9.91,9.91,0,0,0-9.34,6.63l-10.86,30.93a4.52,4.52,0,0,0,.58,4.16,4.52,4.52,0,0,0,3.73,1.93h22.52a6.71,6.71,0,0,0,5.82-4.13l1.45-4.14a.3.3,0,0,0,0-.28.3.3,0,0,0-.25-.13H887a1.29,1.29,0,0,1-1.05-.54,1.29,1.29,0,0,1-.18-1.12l0-.05,8.06-23a2.37,2.37,0,0,1,2.22-1.58h14.3A9.92,9.92,0,0,0,919.68-283.46Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M958.81-275.12h0l-8.06,23a2.36,2.36,0,0,1-2.22,1.57H926.89a1.29,1.29,0,0,1-1-.54,1.3,1.3,0,0,1-.17-1.17l8.06-23a2.36,2.36,0,0,1,2.22-1.58h21.63a1.29,1.29,0,0,1,1.05.54A1.29,1.29,0,0,1,958.81-275.12Zm12-4.31a4.51,4.51,0,0,0-.58-4.15,4.53,4.53,0,0,0-3.73-1.93h-32.6a9.91,9.91,0,0,0-9.34,6.63l-10.86,30.93a4.52,4.52,0,0,0,.58,4.16,4.52,4.52,0,0,0,3.73,1.93h32.6a9.92,9.92,0,0,0,9.34-6.63Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M812.47-285.51a4.58,4.58,0,0,0-4.32,3.06l-11.36,32.38a6.1,6.1,0,0,0,.79,5.61,6.1,6.1,0,0,0,5,2.6h18.74a6.17,6.17,0,0,0,5.82-4.13l1.45-4.14a.3.3,0,0,0,0-.28.3.3,0,0,0-.25-.13H810.68a2.33,2.33,0,0,1-1.92-1,2.33,2.33,0,0,1-.3-2.14l11-31.42a.3.3,0,0,0,0-.28.31.31,0,0,0-.25-.13Z"
          transform="translate(-317.38 526.01)"
        />
        <path
          class="cls-1"
          d="M1014.28-242.07h5.07c2.77,0,5.69-1.91,6.36-4.17l12.15-33.25a4.2,4.2,0,0,0-.79-3.74,6.27,6.27,0,0,0-5-2.45H989.6c-4.89,0-9,2.69-10.18,6.7l-8.7,25-4.22,11.42a.33.33,0,0,0,.08.18.66.66,0,0,0,.52.25h5.07a7,7,0,0,0,6.37-4.19L988.86-274a2.36,2.36,0,0,1,2.34-1.58h8.47a1.46,1.46,0,0,1,1.17.58,1.24,1.24,0,0,1,.2,1.11l-8.65,22.19a.53.53,0,0,0,.08.16.66.66,0,0,0,.52.25h2.2a10.47,10.47,0,0,0,10.21-6.78l6.79-16a2.36,2.36,0,0,1,2.32-1.54h9.38a1.48,1.48,0,0,1,1.17.58,1.25,1.25,0,0,1,.21,1.11l-11.6,31.42a.35.35,0,0,0,.08.18A.65.65,0,0,0,1014.28-242.07Z"
          transform="translate(-317.38 526.01)"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    width: {
      type: Number,
      default: 117,
      required: false
    },
    height: {
      type: Number,
      default: 50,
      required: false
    }
  },
  computed: {
    style() {
      return `width:${this.width}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/style";

.logo {
  svg path {
    fill: $white;
  }
}

.cls-1 {
  fill-rule: evenodd;
}
</style>
